import {
  LOADING_PEOPLE_CONTACTS,
  RECEIVE_PEOPLE_CONTACTS,
  RECEIVE_PEOPLE_CONTACTS_ERROR
} from '../../Constants/action-types';

const initialState = {
  isLoadingPeopleContacts: false,
  people: {
    search_count: 0,
    search_query: {},
    search_result: []
  }
};

export const filterNotRepeated = (arr, item) => {
  const exists = !!arr.find((x) => {
    if (x.isExpertReply) {
      return x.expertReplyId === item.expertReplyId; // may be an error point keep an eye out
    } else {
      return x.id === item.id;
    }
  });
  if (!exists) {
    arr.push(item);
  }

  if (exists && item.delete) {
    arr = arr.filter((x) => x.id !== item.id);
  }

  if (exists && item.edit) {
    arr = arr.filter((x) => x.id !== item.id);
    arr.push(item);
  }

  return arr.sort(function (a, b) {
    return a.time - b.time;
  });
};

export default function personSearchReducer(state = initialState, action) {
  switch (action.type) {
    case LOADING_PEOPLE_CONTACTS:
      return { ...state, isLoadingPeopleContacts: true };
    case RECEIVE_PEOPLE_CONTACTS:
      return { ...state, isLoadingPeopleContacts: false, people: action.payload };
    case RECEIVE_PEOPLE_CONTACTS_ERROR:
      return {
        ...state,
        isLoadingPeopleContacts: false,
        people: {
          search_count: 0,
          search_query: {},
          search_result: []
        }
      };

    default:
      return state;
  }
}
